// extracted by mini-css-extract-plugin
export default {"backButton":"Back_backButton__i3ZX8"};